<i18n>
{
  "en": {
    "name": "Event name",
    "description": "Description",
    "createEventTypeTitle": "Creating event",
    "editEventTypeTitle": "Editing event",
    "emptyFieldError": "Required field",
    "important": "Important",
    "isPositive": "Does it have a positive influence?",
    "color": "Event type color"
  },
  "es": {
    "name": "Nombre de evento",
    "description":  "Descripción",
    "createEventTitle": "Creando evento",
    "editEventTitle": "Editando evento",
    "emptyFieldError": "Campo obligatorio",
    "important":  "Importante",
    "isPositive": "¿Es un evento con influencia positiva?",
    "color": "Color del tipo de evento"
  }
}
</i18n>
<template>
  <v-dialog v-model="visible" max-width="600px" scrollable persistent>
    <v-card v-if="visible" scrollable persistent class="px-7 py-4">
      <v-card-title class="pa-0 mb-2">
        {{ modalTitle }}
      </v-card-title>
      <v-sheet style="background-color: #ffffff">
        <v-form v-model="valid" ref="form">
          <!-- Name and description -->
          <v-text-field :disabled="type === 'edit'"
                        v-model="eventType.name" :rules="nameRules"
                        :label="$t('name')" class="required"/>
          <v-text-field v-model="eventType.description" :rules="descriptionRules"
                        :label="$t('description')" class="required"/>
          <!-- Positive and color -->
          <v-switch v-model="eventType.isPositive" :label="$t('isPositive')"/>
          <v-divider class="mb-3"/>
          <label class="v-label v-label--active theme--light position-elements">
            {{ $t('color') }}
          </label>
          <v-row justify="center">
            <v-color-picker v-model="eventType.color" hide-mode-switch
                            mode="hexa">
            </v-color-picker>
          </v-row>
          <dynameat-modal-buttons class="mt-3"
                                  @cancel="onCancel" @confirm="onConfirm"
                                  :confirmDisabled="!valid"/>
        </v-form>
      </v-sheet>
    </v-card>
  </v-dialog>
</template>
<script>
import {
  notEmptyString
} from '@core/helpers/formValidators';
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import { Prop, Watch } from 'vue-property-decorator';
import Vue from 'vue';
import DynameatModalButtons from '@dynameat/components/DynameatModalButtons';
import { EventType } from '@eventManager/models';

@Component
@Components({ DynameatModalButtons })
export default class EventTypeCreateEditModal extends Vue {
  @Prop({
    Object,
    validator(eventType) {
      return eventType instanceof EventType;
    }
  }) eventType;

  @Prop({
    String,
    default: 'create',
    validator(type) {
      return type === 'create' || type === 'edit';
    }
  }) type;

  @Prop({ Boolean, default: false }) visible;

  valid = false;

  get modalTitle() {
    return this.$t(`${this.type}EventTypeTitle`);
  }

  get nameRules() {
    return [notEmptyString(this.$t('emptyFieldError'))];
  }

  get descriptionRules() {
    return [notEmptyString(this.$t('emptyFieldError'))];
  }

  onCancel() {
    this.$emit('cancel');
  }

  onConfirm() {
    if (this.$refs.form.validate()) {
      this.$emit('confirm', this.eventType);
    }
  }

  @Watch('eventType', { immediate: true })
  onEventTypeChanged(newEventType) {
    if (newEventType) {
      this.eventType.guid = newEventType.guid;
      this.eventType.name = newEventType.name;
      this.eventType.description = newEventType.description;
      this.eventType.isPositive = newEventType.isPositive;
      this.eventType.color = newEventType.color;
    }
  }
}
</script>
<style scoped>

</style>
